// Browsers cannot confirm that a bank app opened. Stop conservatively on any
// departure, including a system prompt, and never resume when the user returns.
export function startBankLinkSequence(urls: string[], onFinish: () => void): () => void {
    let stopped = false;
    let timer: ReturnType<typeof setTimeout> | undefined;
    let index = 0;
    const cancel = () => {
        stopped = true;
        clearTimeout(timer);
        document.removeEventListener('visibilitychange', onVisibilityChange);
        window.removeEventListener('pagehide', finish);
        window.removeEventListener('blur', finish);
    };
    const finish = () => {
        if (stopped) return;
        cancel();
        onFinish();
    };
    const onVisibilityChange = () => {
        if (document.visibilityState === 'hidden') finish();
    };
    const attempt = () => {
        if (stopped) return;
        if (document.visibilityState === 'hidden' || index >= urls.length) {
            finish();
            return;
        }
        // Schedule before navigation so a synchronous departure can cancel it.
        timer = setTimeout(attempt, 1500);
        try {
            window.location.assign(urls[index++]);
        } catch {
            // A browser may reject scripted app launches. Offer direct links.
            finish();
        }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    window.addEventListener('pagehide', finish);
    window.addEventListener('blur', finish);
    attempt();
    return cancel;
}
